import * as actionTypes from "../action-types";

const initialState = {
    //! Customer 
    userCustomerDataById: null,
    useCustomerCompletedQueueListData: null,
    userCustomerWalletHistoryData: [],
    userCustomerTransactionHistoryData: [],
    userCustomerOrderHistoryData: [],
    userCustomerPujaBookHistoryData: [],
    userCustomerAddressData: [],
    userCustomerConsultationHistoryData: {},
    //! Astrologer 
    userAstrologerDataById: null,
    userAstrologerPendingQueueListData: null,
    userAstrologerCompletedQueueListData: null,
    userAstrologerWalletHistoryData: [],
    userAstrologerTransactionHistoryData: [],
    userAstrologerTransactionHistoryData: [],
    userAstrologerRegisteredPujaHistoryData: [],
    userAstrologerAssignedPujaHistoryData: [],
    userAstrologerBookedPujaHistoryData: [],
    userAstrologerConsultationHistoryData: {},
    
    //* Consultation
    slotDurationData: [],
    userAstrologerSlotDateData: [],
    userAstrologerSlotTimeByDateData: {},
    //! Predefined Message
    userQueuePredefinedMessageData: []
};

const userReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Customer 
        case actionTypes.SET_USER_CUSTOMER_BY_ID:
            return { ...state, userCustomerDataById: payload };

        case actionTypes.SET_USER_CUSTOMER_COMPLETED_QUEUE_LIST:
            return { ...state, userCustomerCompletedQueueListData: payload };

        case actionTypes.SET_USER_CUSTOMER_WALLET_HISTORY:
            return { ...state, userCustomerWalletHistoryData: payload };

        case actionTypes.SET_USER_CUSTOMER_TRANSACTION_HISTORY:
            return { ...state, userCustomerTransactionHistoryData: payload };

        case actionTypes.SET_USER_CUSTOMER_ORDER_HISTORY:
            return { ...state, userCustomerOrderHistoryData: payload };

        case actionTypes.SET_USER_CUSTOMER_PUJA_BOOK_HISTORY:
            return { ...state, userCustomerPujaBookHistoryData: payload };

        case actionTypes.SET_USER_CUSTOMER_ADDRESS:
            return { ...state, userCustomerAddressData: payload };

        case actionTypes.SET_USER_CUSTOMER_CONSULTATION_HISTORY:
            return { ...state, userCustomerConsultationHistoryData: payload };

        case actionTypes.SET_USER_ASTROLOGER_CONSULTATION_HISTORY:
            return { ...state, userAstrologerConsultationHistoryData: payload };

        //! Astrologer 
        case actionTypes.SET_USER_ASTROLOGER_BY_ID:
            return { ...state, userAstrologerDataById: payload };

        case actionTypes.SET_USER_ASTROLOGER_PENDING_QUEUE_LIST:
            return { ...state, userAstrologerPendingQueueListData: payload };

        case actionTypes.SET_USER_ASTROLOGER_COMPLETED_QUEUE_LIST:
            return { ...state, userAstrologerCompletedQueueListData: payload };

        case actionTypes.SET_USER_ASTROLOGER_WALLET_HISTORY:
            return { ...state, userAstrologerWalletHistoryData: payload };

        case actionTypes.SET_USER_ASTROLOGER_TRANSACTION_HISTORY:
            return { ...state, userAstrologerTransactionHistoryData: payload };

        case actionTypes.SET_USER_ASTROLOGER_REGISTERED_PUJA_HISTORY:
            return { ...state, userAstrologerRegisteredPujaHistoryData: payload };

        case actionTypes.SET_USER_ASTROLOGER_ASSIGNED_PUJA_HISTORY:
            return { ...state, userAstrologerAssignedPujaHistoryData: payload };

        case actionTypes.SET_USER_ASTROLOGER_BOOKED_PUJA_HISTORY:
            return { ...state, userAstrologerBookedPujaHistoryData: payload };

        //* Consultation
        case actionTypes.SET_SLOT_DURATION:
            return { ...state, slotDurationData: payload };

        case actionTypes.SET_USER_ASTROLOGER_SLOT_DATE:
            return { ...state, userAstrologerSlotDateData: payload };

        case actionTypes.SET_USER_ASTROLOGER_SLOT_TIME_BY_DATE:
            return { ...state, userAstrologerSlotTimeByDateData: payload };

        //! Predefined Message
        case actionTypes.SET_USER_QUEUE_PREDEFINED_MESSAGE:
            return { ...state, userQueuePredefinedMessageData: payload };

        default:
            return state;
    }
};

export default userReducer;